import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNotionComponent } from './simple-icons-notion.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNotionComponent ],
    exports:      [ SimpleIconsNotionComponent ],
    bootstrap:    []
})
export class SimpleIconsNotionModule {}
